import { get } from 'lodash';
import { IPostPayment } from '../data/entities/post-payment/index';
import { IConfiguredHttp } from './http';

export interface IPostPaymentCreationResult {
	statusCode: number;
	postPayments?: IPostPayment[];
}

export interface IPostPaymentsApi {
	createPostPayment: (postPayments: IPostPayment[], propertyId: string, eventId: string) => Promise<IPostPaymentCreationResult>;
	deletePostPayment: (id: number, propertyId: string, eventId: string) => Promise<IPostPaymentCreationResult>;
}

const postPaymentsApiFactory = (http: IConfiguredHttp, prefix = ''): IPostPaymentsApi => ({
	async createPostPayment(postPayments: IPostPayment[], propertyId: string, eventId: string) {
		try {
			const response = await http.post(`${prefix}/property/${propertyId}/booking/${eventId}/post_payment`, postPayments);

			return {
				statusCode: response.status,
				postPayments: response.data
			};
		} catch (err) {
			return { statusCode: get(err, 'response.status', -1) };
		}
	},
	async deletePostPayment(id: number, propertyId: string, eventId: string) {
		try {
			const response = await http.delete(`${prefix}/property/${propertyId}/booking/${eventId}/post_payment/${id}`);

			return { statusCode: response.status };
		} catch (err) {
			return { statusCode: get(err, 'response.status', -1) };
		}
	}
});

export default postPaymentsApiFactory;
